import { useMachine } from '@xstate/react';
import { useState } from 'react';
import { ProviderEntity } from '../../models/provider';
import { CredentialsEntity } from '../../models/credentials';
import {
  createCredentialsMachine,
  CredentialsMachineProps,
} from '../machines/credentialsMachine/credentialsMachine';

export type UseCredentialsMachineProps = Pick<
  CredentialsMachineProps,
  'onDone' | 'onAuthError' | 'waitForUpdated'
> & {
  providedCredentials: CredentialsEntity;
  provider: ProviderEntity;
};

export const useCredentialsMachine = ({
  provider,
  onDone,
  onAuthError,
  waitForUpdated,
  providedCredentials,
}: UseCredentialsMachineProps) => {
  const [machine] = useState(
    createCredentialsMachine({
      initialContext: {
        credentials: providedCredentials,
      },
      provider,
      onDone,
      onAuthError,
      waitForUpdated,
    })
  );

  return useMachine(machine);
};
